<template>
    <admin-layout class="test-page">
        <div class="container-fluid">

            <div class="form-group">
                <button class="btn btn-primary" @click="start()">Get Project</button>
            </div>

            <template v-if="project">

                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           placeholder="Project Name"
                           v-model="project.name"
                           @change="save('name')">
                </div>

                <h6>List Objects</h6>

                <div class="form-group input-group" v-for="(item, index) in project.list" :key="item.id">
                    <input type="text"
                           class="form-control"
                           placeholder="List Item"
                           v-model="project.list[index].value"
                           @change="save('list')">
                    <div class="input-group-append">
                        <button class="btn btn-danger" @click="removeListItem(index)">x</button>
                    </div>
                </div>

                <button class="btn btn-primary" @click="addListItem()">Add List Item</button>

            </template>

            <pre class="bg-dark text-light p-3 my-3">{{ project }}</pre>

        </div>
    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import {mapActions} from "vuex";
import API from "@/API";
export default {
    name: "TestPage",
    components: {AdminLayout},

    data(){
        return {
            projectScope: {name: API.fragments.SCOPE_PROJECT, id: 1},
            projectRepo: null,
            project: null,
        }
    },

    methods: {

        ...mapActions('repositories', {
            repo: 'getRepository',
            freeRepo: 'freeRepository',
            updateRepo: 'updateRepository',
        }),

        async start(){
            this.projectRepo = (await this.repo( this.projectScope ));
            this.project = this.projectRepo.fragments;
        },

        save(name){
            const fragments = {};
            fragments[name] = this.project[name];
            this.updateRepo({scope: this.projectScope, fragments});
        },

        addListItem(){
            if( typeof this.project.list === "undefined" ){
                this.project.list = [];
            }
            this.project.list.push({
                id: 'item-' + Math.floor( Math.random() * 1000000 ),
                value: '',
            });
            this.save('list');
        },

        removeListItem(index){
            if( typeof this.project.list === "undefined" ){
                this.project.list = [];
            }
            this.project.list.splice(index, 1);
            this.save('list');
        }

    },

    async mounted() {
        // this.start();
    },

    beforeUnmount() {
        this.freeRepo( this.projectScope );
    }

}
</script>

<style scoped>

</style>
